import type { ReactNode } from 'react';
import { ROLES, type Role } from '@cp/shared';
import { Checkbox } from '@/components/ui';
import { label, ROLE_HINTS, ROLE_LABELS } from '@/utils/labels';

/** Every role as a checkbox with what it allows beside it. */
export function RolePicker({
  value,
  onChange,
  disabled = false,
}: {
  readonly value: readonly Role[];
  readonly onChange: (roles: Role[]) => void;
  readonly disabled?: boolean;
}): ReactNode {
  const toggle = (role: Role): void => {
    onChange(value.includes(role) ? value.filter((item) => item !== role) : [...value, role]);
  };

  return (
    <fieldset className="field fieldset">
      <legend className="field-label">Роли</legend>
      <div className="stack stack-tight">
        {ROLES.map((role) => (
          <Checkbox
            key={role}
            checked={value.includes(role)}
            disabled={disabled}
            onChange={() => toggle(role)}
            label={label(ROLE_LABELS, role)}
            hint={ROLE_HINTS[role] ?? ''}
          />
        ))}
      </div>
    </fieldset>
  );
}
